export const COLORS = {
  backgroundColorDarkTheme: 'var(--app-bg)',
  tableBackgroundColor: 'var(--app-surface-1)',
  tableHeaderColor: 'var(--app-surface-header)',
  borderColorDarkTheme: 'var(--app-table-border)',
  fontColorDarkTheme: 'var(--app-text)',
};

export const STATUS_CONFIG: Record<string, { label: string; color: 'success' | 'warning' | 'error' | 'info' }> = {
  Queued: { label: 'Na fila', color: 'info' },
  Processing: { label: 'Processando', color: 'warning' },
  Completed: { label: 'Concluído', color: 'success' },
  Failed: { label: 'Falhou', color: 'error' },
};
